import React, { PropTypes } from 'react';
import PeriodFromTo from '../periodFromTo/PeriodFromTo';

const CoverageInformation = (props) => {
  return (
    <div className="ebaoUtil__Top-Bottom-Line">
      <h3 className="ebaoUtil__HeaderThree">Coverage Information</h3>
        <PeriodFromTo
          startDate={props.coverageInfo.coveragePeriodFrom}
          endDate={props.coverageInfo.coveragePeriodTo}
          startDateLabel="Period From *"
          endDateLabel="To *"
          handleChangeStartDate={props.handleChangeCoverageInfoPreviousFrom}
          handleChangeEndDate={props.handleChangeCoverageInfoPreviousTo}
        />
    </div>
  )
}

CoverageInformation.propTypes = {
  coverageInfo: PropTypes.object,
  handleChangeCoverageInfoPreviousTo: PropTypes.func,
  handleChangeCoverageInfoPreviousFrom: PropTypes.func
};

export default CoverageInformation;



// WEBPACK FOOTER //
// ./src/app/components/coverageInformation/CoverageInformation.js